import $ from 'jquery';

import '../class/sk';
import '../class/sk.widgets.Suggest';
import '../class/sk.widgets.SuggestMenu';

export const init = ($target) => {

	$target.find('.js-suggest').each(function() {

		var $this = $(this),
			$input = $this.find('.js-suggest__inp');

		var $menu = $('<div class="b-suggest js-toggle" aria-label="Naseptavac" aria-controls="whisperer" id="whisperer" aria-expanded="false"></div>').appendTo( $this );

		var Suggest = new sk.widgets.Suggest($input, {
			minLength: 2,
			typeInterval: 250,
			url: $this.data('suggest'),
		});

		var SuggestMenu = new sk.widgets.SuggestMenu($menu, Suggest, {
			'item': '.js-suggest__item',
		}).init();

		$(SuggestMenu)
			.on('menuselect', function(e) {
				var $item = this.$items.eq( this.selectedIndex-1 );

				if ( $item.hasClass('js-suggest__item--btn') ) {
					e.preventDefault();

					$this.submit();
				}
				else {
					window.location = $item.find('a').attr('href');
				}
			});

		$this.on('click', '.js-suggest__item--btn a', function(e) {
			e.preventDefault();

			$this.submit();
		});
	});

};
